import styled from 'styled-components';

export const BtnWrapper = styled.div`
    display: flex;
    position: relative;
`

export const Marker = styled.div`
    width: 10px;
    height: ${props => props.height};
    transform: skew(${props => props.rotation});
    background: ${props => props.background} none repeat scroll 0% 0%;
    position: absolute;
    ${props => props.right ? `right: ${props.right}` : null}
`

export const LeftTriangle = styled.div`
    border-top: ${props => props.height} solid ${props => props.background};
    border-left: 25px solid transparent;
`

export const Text = styled.span`
    padding: 10px 35px;
    background: rgba(0, 0, 0, 0) linear-gradient(90deg, ${props => props.leftGradiant} 0%, ${props => props.rightGradiant} 100%) repeat scroll 0% 0%;
    display: inline-block;
    font-family: Millenia;
    font-size: ${props => props.size};
    width: 100%;
    cursor: pointer;
`

export const RightTriangle = styled.div`
    border-bottom: ${props => props.height} solid ${props => props.background};
    border-right: 25px solid transparent;
`